import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// {/* <div class="root"></div> */}

// ReactDOM.render(<div>test</div>,document.getElementById('root'));

ReactDOM.render(<App />,document.getElementById('root'));